import { size, color as foundationColor} from "../foundation";
import { color, spacing, effects } from "../semantic";

export const panel = {
    color: {
        border: color.border.default.light,
        bg: {
            header: foundationColor.neutral[50],
            body: color.bg.surface,
            footer: color.bg.surface,
        },
        icon: color.icons.heading
    },
    spacing: {
        header:
        {
            padding: {
                x: spacing.sm,   
                y: spacing.xs,   
            },
        },
        body: {
            padding: {
                default: spacing.sm,   // padding on all sides  16px
                none: spacing.none,    // no padding (for panels containing card lists)
            },
            card: {
                gap: '-1px',    // prevents double border for panels containing card lists
            }
        },
        footer: {
            padding: {
                x: spacing.sm,  
                y: spacing.xxs,    
            }
        },
    },
    size: {
        header: {
            minHeight: size[1350],
        },
        icon: {
            fontSize: size[500],  // action icon (expand, collapse, etc.)
            containerSize: size[600] // smaller icon container than the default icon button size
        },
        footerButton: size[800] // buttons in the panel footer height
    },
    effects: {
        radius: effects.radius.md,
        iconRadius: effects.radius.sm,
    },
};

export default panel;